import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHead, ServiceTile } from '../ui';
import { MORE_SERVICES } from '../../data/home';

export default function MoreServices() {
  const { t } = useTranslation();
  return (
    <div className="more">
      <SectionHead eyebrow={t('Upcoming Services')} title={t('More Services On The Way')} />
      <div className="grid-3">
        {MORE_SERVICES.map((s) => (
          <ServiceTile key={s.title} icon={s.icon} title={t(s.title)} desc={t(s.desc)} to={s.to} comingSoon={!!s.comingSoon} soonLabel={t('Coming Soon')} />
        ))}
      </div>
    </div>
  );
}
